import Html5Entities from '../../external/npm/html5-entities.js';
import { projectFormatter } from './projectFormatter.js';


/**
 * Provides methods to create JSX snippets that can be used in project cards and give widgets
 */
export const hasMatch = function (project) {
    if (project.matchingFund && project.matchingFund.type) {
        return true;
    }
};

export const makeTeacherAndSchoolInfo = function (project) {
    // For privacy reasons, hide city if we're showing photos or if the teacher's hidedetails flag is set to true
    var hideLocation = project.hideTeacherDetails || (project.thankYouAssets && project.thankYouAssets.photos);
    const location = hideLocation ? project.stateFullName : project.city + ', ' + project.state;

    return (
        <div>
            <span className="name">{Html5Entities.decode(project.teacherName)}</span>
            <div className='school-info'>
                {!project.hideTeacherDetails &&
                    <div className='school-name'>
                        {Html5Entities.decode(project.schoolName)}
                        <span className='school-separator'>{Html5Entities.decode('&bull;')}</span>
                    </div>
                }
                <span className='school-location'>{Html5Entities.decode(location)}</span>
            </div>
        </div>
    );
};

export const makeStillNeeded = function (project) {
    if (project.completingDonationAmount) {
        return project.completingDonationAmount;
    }
    var matchedAmount = (project.matchingFund && project.matchingFund.matchImpactMultiple) ? project.matchingFund.matchImpactMultiple : 1;
    return Math.ceil(project.costToComplete / matchedAmount);
};

export const makeStillNeededWithMatch = function (project) {
    return projectFormatter.formatCurrency(makeStillNeeded(project));
};

export const makeStillNeededFormatted = function (project) {
    return projectFormatter.formatCurrency(makeStillNeeded(project));
};
